module.exports = __webpack_public_path__ + "5c32818e9e57734ffc9d00d0777738c3.svg";